import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title id="Tv">{props.title || 'Tv'}</title>
      <g>
        <path d="M488 145.6c-44.8-6.4-91.2-11.2-140.8-14.4l83.2-83.2-32-32-112 112h-32l-128-128-32 32 97.6 97.6c-60.8 1.6-118.4 8-171.2 14.4-14.4 54.4-20.8 113.6-20.8 176 0 62.4 8 121.6 20.8 176 72 9.6 150.4 16 235.2 16 84.8 0 163.2-6.4 235.2-16 14.4-54.4 20.8-113.6 20.8-176 0-62.4-11.2-120-24-174.4zm-59.2 292.8c-54.4 6.4-113.6 11.2-176 11.2-62.4 0-121.6-3.2-176-11.2-9.6-35.2-16-75.2-16-116.8 0-41.6 6.4-81.6 16-116.8 54.4-6.4 113.6-11.2 176-11.2 62.4 0 121.6 3.2 176 11.2 9.6 35.2 16 75.2 16 116.8 0 41.6-6.4 81.6-16 116.8z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/tv.js